import script from "./private-event-footer.view.vue?vue&type=script&setup=true&lang=js"
export * from "./private-event-footer.view.vue?vue&type=script&setup=true&lang=js"

import "./private-event-footer.view.vue?vue&type=style&index=0&id=3b1d7377&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1d7377"]])

export default __exports__